import { CSSProperties, ReactElement, ReactNode, useMemo } from 'react';

import { useFloorMap } from './FloorMapProvider';
import { RenderBookingObjectParams } from './types';

export interface BookingObjectsProps<T> {
  items: Map<string, T>;
  renderBookingObject: (params: RenderBookingObjectParams<T>) => ReactNode;
}

export const BookingObjects = <T,>({
  items,
  renderBookingObject,
}: BookingObjectsProps<T>): ReactElement => {
  const { backgroundData } = useFloorMap();

  const nodes = useMemo((): ReactNode[] => {
    const result: ReactNode[] = [];

    for (const bookingObject of items.values()) {
      result.push(renderBookingObject({ bookingObject }));
    }

    return result;
  }, [items, renderBookingObject]);

  const style = useMemo(
    (): CSSProperties => ({
      width: `${backgroundData?.width}px`,
      height: `${backgroundData?.height}px`,
    }),
    [backgroundData?.height, backgroundData?.width],
  );

  return <div style={style}>{nodes}</div>;
};
